// extracted by mini-css-extract-plugin
export default {"rating":"JB-z","numberOfStars":"KB-z","count":"LB-z","barGraphSpacing":"MB-z","barGraph":"NB-z"};